export const carbonImpurities = [
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 171.69,
                        assignment: 'CO',
                    },
                ],
                from: 171.685,
                to: 171.695,
            },
            {
                signals: [
                    {
                        delta: 20.13,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.125,
                to: 20.134999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204.19,
                        assignment: 'CO',
                    },
                ],
                from: 204.185,
                to: 204.195,
            },
            {
                signals: [
                    {
                        delta: 30.17,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.165000000000003,
                to: 30.175,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.79,
                        assignment: 'CN',
                    },
                ],
                from: 116.78500000000001,
                to: 116.795,
            },
            {
                signals: [
                    {
                        delta: 0.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.445,
                to: 0.455,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.84,
                        assignment: 'CH',
                    },
                ],
                from: 128.835,
                to: 128.845,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.5,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 67.495,
                to: 67.505,
            },
            {
                signals: [
                    {
                        delta: 30.57,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.565,
                to: 30.575,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.69,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.685,
                to: 125.695,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.37,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.365,
                to: 193.375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.89,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.885,
                to: 96.895,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.24,
                        assignment: 'CH',
                    },
                ],
                from: 79.235,
                to: 79.24499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.34,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.33500000000001,
                to: 71.345,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.58,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.575,
                to: 27.584999999999997,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 44.64,
                        assignment: 'CH₂',
                    },
                ],
                from: 44.635,
                to: 44.645,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.67,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.665,
                to: 54.675000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.485,
                to: 15.495000000000001,
            },
            {
                signals: [
                    {
                        delta: 66.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.135,
                to: 66.145,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.714999999999996,
                to: 58.725,
            },
            {
                signals: [
                    {
                        delta: 71.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.165,
                to: 71.175,
            },
            {
                signals: [
                    {
                        delta: 72.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.715,
                to: 72.725,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 161.96,
                        assignment: 'CH',
                    },
                ],
                from: 161.955,
                to: 161.965,
            },
            {
                signals: [
                    {
                        delta: 35.65,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.644999999999996,
                to: 35.655,
            },
            {
                signals: [
                    {
                        delta: 30.7,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.695,
                to: 30.705,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.65,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.64500000000001,
                to: 67.655,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.714999999999996,
                to: 58.725,
            },
            {
                signals: [
                    {
                        delta: 72.58,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.575,
                to: 72.585,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.79,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.785,
                to: 6.795,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.895,
                to: 18.904999999999998,
            },
            {
                signals: [
                    {
                        delta: 57.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.595,
                to: 57.605000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.45,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.445,
                to: 20.455,
            },
            {
                signals: [
                    {
                        delta: 170.32,
                        assignment: 'CO',
                    },
                ],
                from: 170.315,
                to: 170.325,
            },
            {
                signals: [
                    {
                        delta: 60.3,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.294999999999995,
                to: 60.305,
            },
            {
                signals: [
                    {
                        delta: 14.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.364999999999998,
                to: 14.375,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.09,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.08500000000001,
                to: 123.095,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.35,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.345,
                to: 64.35499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.45,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.445,
                to: 30.455,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.88,
                        assignment: 'C',
                    },
                ],
                from: 131.875,
                to: 131.885,
            },
            {
                signals: [
                    {
                        delta: 16.71,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.705000000000002,
                to: 16.715,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.215,
                to: 14.225000000000001,
            },
            {
                signals: [
                    {
                        delta: 23.33,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.325,
                to: 23.334999999999997,
            },
            {
                signals: [
                    {
                        delta: 32.34,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.335,
                to: 32.345000000000006,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.83,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.8250000000000002,
                to: 1.835,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.885,
                to: 36.895,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.72,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.715,
                to: 135.725,
            },
            {
                signals: [
                    {
                        delta: 122.2,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.19500000000001,
                to: 122.205,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.9,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.905,
                to: -4.8950000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.64,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.635,
                to: 49.645,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 62.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 62.485,
                to: 62.495000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.18,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.174999999999999,
                to: 14.185,
            },
            {
                signals: [
                    {
                        delta: 23,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.995,
                to: 23.005,
            },
            {
                signals: [
                    {
                        delta: 34.87,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.864999999999995,
                to: 34.875,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.6,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.595000000000002,
                to: 16.605,
            },
            {
                signals: [
                    {
                        delta: 16.82,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.815,
                to: 16.825,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.7,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.695,
                to: 25.705,
            },
            {
                signals: [
                    {
                        delta: 66.14,
                        assignment: 'CH',
                    },
                ],
                from: 66.135,
                to: 66.145,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.265,
                to: 19.275,
            },
            {
                signals: [
                    {
                        delta: 115.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.735,
                to: 115.74499999999999,
            },
            {
                signals: [
                    {
                        delta: 134.02,
                        assignment: 'CH',
                    },
                ],
                from: 134.01500000000001,
                to: 134.025,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.57,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.565,
                to: 150.575,
            },
            {
                signals: [
                    {
                        delta: 124.08,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 124.075,
                to: 124.085,
            },
            {
                signals: [
                    {
                        delta: 135.99,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.985,
                to: 135.995,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.03,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 118.025,
                to: 118.035,
            },
            {
                signals: [
                    {
                        delta: 107.74,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.735,
                to: 107.74499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.82,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 45.815,
                to: 45.825,
            },
            {
                signals: [
                    {
                        delta: 26.17,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.165000000000003,
                to: 26.175,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.195,
                to: 1.2049999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.03,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.025,
                to: 68.035,
            },
            {
                signals: [
                    {
                        delta: 26.19,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.185000000000002,
                to: 26.195,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.29,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.285,
                to: 21.294999999999998,
            },
            {
                signals: [
                    {
                        delta: 138.24,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.235,
                to: 138.245,
            },
            {
                signals: [
                    {
                        delta: 129.47,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.465,
                to: 129.475,
            },
            {
                signals: [
                    {
                        delta: 128.71,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.705,
                to: 128.715,
            },
            {
                signals: [
                    {
                        delta: 125.84,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.83500000000001,
                to: 125.845,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.504999999999999,
                to: 12.515,
            },
            {
                signals: [
                    {
                        delta: 47.18,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.175,
                to: 47.185,
            },
        ],
        nucleus: '13C',
        solvent: 'THF-d₈',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.85,
                        assignment: 'CO',
                    },
                ],
                from: 175.845,
                to: 175.855,
            },
            {
                signals: [
                    {
                        delta: 20.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.905,
                to: 20.915,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 206.78,
                        assignment: 'CO',
                    },
                ],
                from: 206.775,
                to: 206.785,
            },
            {
                signals: [
                    {
                        delta: 31,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.995,
                to: 31.005,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.92,
                        assignment: 'CN',
                    },
                ],
                from: 116.915,
                to: 116.925,
            },
            {
                signals: [
                    {
                        delta: 2.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.025,
                to: 2.0349999999999997,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.68,
                        assignment: 'CH',
                    },
                ],
                from: 128.675,
                to: 128.685,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.11,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 69.105,
                to: 69.115,
            },
            {
                signals: [
                    {
                        delta: 31.46,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.455000000000002,
                to: 31.465,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.26,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.25500000000001,
                to: 125.265,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.95,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.945,
                to: 192.95499999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.52,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.515,
                to: 96.52499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.99,
                        assignment: 'CH',
                    },
                ],
                from: 77.985,
                to: 77.99499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.465,
                to: 70.475,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.38,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.375,
                to: 27.384999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 44.35,
                        assignment: 'CH₂',
                    },
                ],
                from: 44.345,
                to: 44.355000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.24,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.235,
                to: 54.245000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.44,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.434999999999999,
                to: 15.445,
            },
            {
                signals: [
                    {
                        delta: 66.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.105,
                to: 66.115,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.95,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.945,
                to: 58.955000000000005,
            },
            {
                signals: [
                    {
                        delta: 70.7,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.69500000000001,
                to: 70.705,
            },
            {
                signals: [
                    {
                        delta: 72.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.245,
                to: 72.255,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.57,
                        assignment: 'CH',
                    },
                ],
                from: 162.565,
                to: 162.575,
            },
            {
                signals: [
                    {
                        delta: 36.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.555,
                to: 36.565000000000005,
            },
            {
                signals: [
                    {
                        delta: 31.39,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.385,
                to: 31.395,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.465,
                to: 67.475,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.02,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.015,
                to: 59.025000000000006,
            },
            {
                signals: [
                    {
                        delta: 72.24,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.235,
                to: 72.24499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.905,
                to: 6.915,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.69,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.685000000000002,
                to: 18.695,
            },
            {
                signals: [
                    {
                        delta: 58.57,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.565,
                to: 58.575,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.15,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.145,
                to: 21.154999999999998,
            },
            {
                signals: [
                    {
                        delta: 171.24,
                        assignment: 'CO',
                    },
                ],
                from: 171.235,
                to: 171.245,
            },
            {
                signals: [
                    {
                        delta: 60.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.625,
                to: 60.635000000000005,
            },
            {
                signals: [
                    {
                        delta: 14.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.364999999999998,
                to: 14.375,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.2,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.19500000000001,
                to: 123.205,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.08,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.075,
                to: 64.085,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.135,
                to: 30.145,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.09,
                        assignment: 'C',
                    },
                ],
                from: 132.085,
                to: 132.095,
            },
            {
                signals: [
                    {
                        delta: 16.93,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.925,
                to: 16.935,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.28,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.274999999999999,
                to: 14.285,
            },
            {
                signals: [
                    {
                        delta: 23.07,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.065,
                to: 23.075,
            },
            {
                signals: [
                    {
                        delta: 32.01,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.004999999999995,
                to: 32.015,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.955,
                to: 1.9649999999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.985,
                to: 36.995000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.76,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.755,
                to: 135.765,
            },
            {
                signals: [
                    {
                        delta: 122.16,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.155,
                to: 122.16499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.33,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.335,
                to: -4.325,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 50.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 50.445,
                to: 50.455000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.025,
                to: 63.035000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.24,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.235,
                to: 14.245000000000001,
            },
            {
                signals: [
                    {
                        delta: 22.77,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.765,
                to: 22.775,
            },
            {
                signals: [
                    {
                        delta: 34.57,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.565,
                to: 34.575,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.625,
                to: 16.634999999999998,
            },
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.625,
                to: 16.634999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.43,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.425,
                to: 25.435,
            },
            {
                signals: [
                    {
                        delta: 64.67,
                        assignment: 'CH',
                    },
                ],
                from: 64.665,
                to: 64.675,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.465,
                to: 19.474999999999998,
            },
            {
                signals: [
                    {
                        delta: 115.7,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.69500000000001,
                to: 115.705,
            },
            {
                signals: [
                    {
                        delta: 134.21,
                        assignment: 'CH',
                    },
                ],
                from: 134.205,
                to: 134.215,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.27,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.26500000000001,
                to: 150.275,
            },
            {
                signals: [
                    {
                        delta: 124.06,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 124.055,
                to: 124.065,
            },
            {
                signals: [
                    {
                        delta: 136.16,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.155,
                to: 136.165,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.93,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.92500000000001,
                to: 117.935,
            },
            {
                signals: [
                    {
                        delta: 108.02,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.015,
                to: 108.02499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.02,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.015,
                to: 47.025000000000006,
            },
            {
                signals: [
                    {
                        delta: 25.83,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.825,
                to: 25.834999999999997,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.215,
                to: 1.2249999999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.16,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.155,
                to: 68.16499999999999,
            },
            {
                signals: [
                    {
                        delta: 25.98,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.975,
                to: 25.985,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.53,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.525000000000002,
                to: 21.535,
            },
            {
                signals: [
                    {
                        delta: 138.36,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.35500000000002,
                to: 138.365,
            },
            {
                signals: [
                    {
                        delta: 129.35,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.345,
                to: 129.355,
            },
            {
                signals: [
                    {
                        delta: 128.54,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.535,
                to: 128.545,
            },
            {
                signals: [
                    {
                        delta: 125.62,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.61500000000001,
                to: 125.625,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.114999999999998,
                to: 12.125,
            },
            {
                signals: [
                    {
                        delta: 46.75,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.745,
                to: 46.755,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₂Cl₂',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.99,
                        assignment: 'CO',
                    },
                ],
                from: 175.985,
                to: 175.995,
            },
            {
                signals: [
                    {
                        delta: 20.81,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.805,
                to: 20.814999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 207.07,
                        assignment: 'CO',
                    },
                ],
                from: 207.065,
                to: 207.075,
            },
            {
                signals: [
                    {
                        delta: 30.92,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.915000000000003,
                to: 30.925,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.43,
                        assignment: 'CN',
                    },
                ],
                from: 116.42500000000001,
                to: 116.435,
            },
            {
                signals: [
                    {
                        delta: 1.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.885,
                to: 1.8949999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.37,
                        assignment: 'CH',
                    },
                ],
                from: 128.365,
                to: 128.375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.15,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 69.14500000000001,
                to: 69.155,
            },
            {
                signals: [
                    {
                        delta: 31.25,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.245,
                to: 31.255,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.99,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.985,
                to: 124.99499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.83,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.82500000000002,
                to: 192.835,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.34,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.33500000000001,
                to: 96.345,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.36,
                        assignment: 'CH',
                    },
                ],
                from: 77.355,
                to: 77.365,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.55,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.545,
                to: 70.55499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 26.94,
                        assignment: 'CH₂',
                    },
                ],
                from: 26.935000000000002,
                to: 26.945,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.5,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.495,
                to: 43.505,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.52,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.515,
                to: 53.525000000000006,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.194999999999999,
                to: 15.205,
            },
            {
                signals: [
                    {
                        delta: 65.91,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.905,
                to: 65.91499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.01,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.004999999999995,
                to: 59.015,
            },
            {
                signals: [
                    {
                        delta: 70.51,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.50500000000001,
                to: 70.515,
            },
            {
                signals: [
                    {
                        delta: 71.9,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.89500000000001,
                to: 71.905,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.62,
                        assignment: 'CH',
                    },
                ],
                from: 162.615,
                to: 162.625,
            },
            {
                signals: [
                    {
                        delta: 36.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.495,
                to: 36.505,
            },
            {
                signals: [
                    {
                        delta: 31.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.445,
                to: 31.455,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.135,
                to: 67.145,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.08,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.074999999999996,
                to: 59.085,
            },
            {
                signals: [
                    {
                        delta: 71.84,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.83500000000001,
                to: 71.845,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.885,
                to: 6.895,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.41,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.405,
                to: 18.415,
            },
            {
                signals: [
                    {
                        delta: 58.28,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.275,
                to: 58.285000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.04,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.035,
                to: 21.044999999999998,
            },
            {
                signals: [
                    {
                        delta: 171.36,
                        assignment: 'CO',
                    },
                ],
                from: 171.35500000000002,
                to: 171.365,
            },
            {
                signals: [
                    {
                        delta: 60.49,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.485,
                to: 60.495000000000005,
            },
            {
                signals: [
                    {
                        delta: 14.19,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.184999999999999,
                to: 14.195,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.13,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.125,
                to: 123.13499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.79,
                        assignment: 'CH₂',
                    },
                ],
                from: 63.785,
                to: 63.795,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 29.71,
                        assignment: 'CH₂',
                    },
                ],
                from: 29.705000000000002,
                to: 29.715,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.21,
                        assignment: 'C',
                    },
                ],
                from: 132.205,
                to: 132.215,
            },
            {
                signals: [
                    {
                        delta: 16.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.975,
                to: 16.985,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.135,
                to: 14.145000000000001,
            },
            {
                signals: [
                    {
                        delta: 22.7,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 22.695,
                to: 22.705,
            },
            {
                signals: [
                    {
                        delta: 31.64,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 31.635,
                to: 31.645,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.97,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.965,
                to: 1.9749999999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.87,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.864999999999995,
                to: 36.875,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.38,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.375,
                to: 135.385,
            },
            {
                signals: [
                    {
                        delta: 122,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 121.995,
                to: 122.005,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.63,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.635,
                to: -4.625,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 50.41,
                        assignment: 'CH₃',
                    },
                ],
                from: 50.404999999999994,
                to: 50.415,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 62.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 62.495,
                to: 62.505,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.08,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.075,
                to: 14.085,
            },
            {
                signals: [
                    {
                        delta: 22.38,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.375,
                to: 22.384999999999998,
            },
            {
                signals: [
                    {
                        delta: 34.16,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.154999999999994,
                to: 34.165,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.625,
                to: 16.634999999999998,
            },
            {
                signals: [
                    {
                        delta: 16.37,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.365000000000002,
                to: 16.375,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.135,
                to: 25.145,
            },
            {
                signals: [
                    {
                        delta: 64.5,
                        assignment: 'CH',
                    },
                ],
                from: 64.495,
                to: 64.505,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.495,
                to: 19.505,
            },
            {
                signals: [
                    {
                        delta: 115.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.735,
                to: 115.74499999999999,
            },
            {
                signals: [
                    {
                        delta: 133.91,
                        assignment: 'CH',
                    },
                ],
                from: 133.905,
                to: 133.915,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.9,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.895,
                to: 149.905,
            },
            {
                signals: [
                    {
                        delta: 123.75,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.745,
                to: 123.755,
            },
            {
                signals: [
                    {
                        delta: 135.96,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.955,
                to: 135.965,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.77,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.765,
                to: 117.77499999999999,
            },
            {
                signals: [
                    {
                        delta: 107.98,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.97500000000001,
                to: 107.985,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.93,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.925,
                to: 46.935,
            },
            {
                signals: [
                    {
                        delta: 25.56,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.555,
                to: 25.564999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.19,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.185,
                to: 1.1949999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.97,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.965,
                to: 67.975,
            },
            {
                signals: [
                    {
                        delta: 25.62,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.615000000000002,
                to: 25.625,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.455000000000002,
                to: 21.465,
            },
            {
                signals: [
                    {
                        delta: 137.89,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.885,
                to: 137.89499999999998,
            },
            {
                signals: [
                    {
                        delta: 129.07,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.065,
                to: 129.075,
            },
            {
                signals: [
                    {
                        delta: 128.26,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.255,
                to: 128.265,
            },
            {
                signals: [
                    {
                        delta: 125.33,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.325,
                to: 125.335,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.61,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.604999999999999,
                to: 11.615,
            },
            {
                signals: [
                    {
                        delta: 46.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.245,
                to: 46.255,
            },
        ],
        nucleus: '13C',
        solvent: 'CDCl₃',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.3,
                        assignment: 'CO',
                    },
                ],
                from: 175.29500000000002,
                to: 175.305,
            },
            {
                signals: [
                    {
                        delta: 20.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.265,
                to: 20.275,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204,
                        assignment: 'CO',
                    },
                ],
                from: 203.995,
                to: 204.005,
            },
            {
                signals: [
                    {
                        delta: 30.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.025000000000002,
                to: 30.035,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 115.76,
                        assignment: 'CN',
                    },
                ],
                from: 115.75500000000001,
                to: 115.765,
            },
            {
                signals: [
                    {
                        delta: 0.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.024999999999999998,
                to: 0.034999999999999996,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.57,
                        assignment: 'CH',
                    },
                ],
                from: 128.565,
                to: 128.575,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.12,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.11500000000001,
                to: 68.125,
            },
            {
                signals: [
                    {
                        delta: 30.49,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.485,
                to: 30.494999999999997,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.86,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.855,
                to: 124.865,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.71,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.705,
                to: 192.715,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.57,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.565,
                to: 96.57499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.89,
                        assignment: 'CH',
                    },
                ],
                from: 77.885,
                to: 77.895,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.86,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.855,
                to: 70.865,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.31,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.305,
                to: 27.314999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.4,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.394999999999996,
                to: 43.405,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.464999999999996,
                to: 53.475,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.465,
                to: 15.475000000000001,
            },
            {
                signals: [
                    {
                        delta: 65.94,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.935,
                to: 65.945,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.62,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.614999999999995,
                to: 58.625,
            },
            {
                signals: [
                    {
                        delta: 70.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.915,
                to: 70.925,
            },
            {
                signals: [
                    {
                        delta: 72.39,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.385,
                to: 72.395,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 161.93,
                        assignment: 'CH',
                    },
                ],
                from: 161.925,
                to: 161.935,
            },
            {
                signals: [
                    {
                        delta: 35.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.214999999999996,
                to: 35.225,
            },
            {
                signals: [
                    {
                        delta: 30.64,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.635,
                to: 30.645,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.165,
                to: 67.175,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.625,
                to: 58.635000000000005,
            },
            {
                signals: [
                    {
                        delta: 72.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.245,
                to: 72.255,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.94,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.9350000000000005,
                to: 6.945,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.78,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.775000000000002,
                to: 18.785,
            },
            {
                signals: [
                    {
                        delta: 57.81,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.805,
                to: 57.815000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.46,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.455000000000002,
                to: 20.465,
            },
            {
                signals: [
                    {
                        delta: 170.02,
                        assignment: 'CO',
                    },
                ],
                from: 170.01500000000001,
                to: 170.025,
            },
            {
                signals: [
                    {
                        delta: 60.08,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.074999999999996,
                to: 60.085,
            },
            {
                signals: [
                    {
                        delta: 14.23,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.225,
                to: 14.235000000000001,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 122.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 122.915,
                to: 122.925,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.29,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.28500000000001,
                to: 64.295,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.31,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.305,
                to: 30.314999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.72,
                        assignment: 'C',
                    },
                ],
                from: 131.715,
                to: 131.725,
            },
            {
                signals: [
                    {
                        delta: 16.84,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.835,
                to: 16.845,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.34,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.334999999999999,
                to: 14.345,
            },
            {
                signals: [
                    {
                        delta: 23.12,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.115000000000002,
                to: 23.125,
            },
            {
                signals: [
                    {
                        delta: 32.06,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.055,
                to: 32.065000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.985,
                to: 1.9949999999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.8,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.794999999999995,
                to: 36.805,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.57,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.565,
                to: 135.575,
            },
            {
                signals: [
                    {
                        delta: 122.13,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.125,
                to: 122.13499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.34,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.345,
                to: -4.335,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.894999999999996,
                to: 49.905,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 61.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 61.135,
                to: 61.145,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.264999999999999,
                to: 14.275,
            },
            {
                signals: [
                    {
                        delta: 22.79,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.785,
                to: 22.794999999999998,
            },
            {
                signals: [
                    {
                        delta: 34.54,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.535,
                to: 34.545,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.65,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.645,
                to: 16.654999999999998,
            },
            {
                signals: [
                    {
                        delta: 16.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.625,
                to: 16.634999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.24,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.235,
                to: 25.244999999999997,
            },
            {
                signals: [
                    {
                        delta: 64.12,
                        assignment: 'CH',
                    },
                ],
                from: 64.11500000000001,
                to: 64.125,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.315,
                to: 19.325,
            },
            {
                signals: [
                    {
                        delta: 115.89,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.885,
                to: 115.895,
            },
            {
                signals: [
                    {
                        delta: 133.61,
                        assignment: 'CH',
                    },
                ],
                from: 133.60500000000002,
                to: 133.615,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.25,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.245,
                to: 150.255,
            },
            {
                signals: [
                    {
                        delta: 123.46,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.455,
                to: 123.46499999999999,
            },
            {
                signals: [
                    {
                        delta: 135.17,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.165,
                to: 135.17499999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.61,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.605,
                to: 117.615,
            },
            {
                signals: [
                    {
                        delta: 108.15,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.14500000000001,
                to: 108.155,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.12,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.114999999999995,
                to: 47.125,
            },
            {
                signals: [
                    {
                        delta: 25.75,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.745,
                to: 25.755,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.3650000000000002,
                to: 1.375,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.75,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.745,
                to: 67.755,
            },
            {
                signals: [
                    {
                        delta: 25.79,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.785,
                to: 25.794999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.365000000000002,
                to: 21.375,
            },
            {
                signals: [
                    {
                        delta: 137.84,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.835,
                to: 137.845,
            },
            {
                signals: [
                    {
                        delta: 129.33,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.32500000000002,
                to: 129.335,
            },
            {
                signals: [
                    {
                        delta: 128.51,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.505,
                to: 128.515,
            },
            {
                signals: [
                    {
                        delta: 125.66,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.655,
                to: 125.66499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.39,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.385,
                to: 12.395000000000001,
            },
            {
                signals: [
                    {
                        delta: 46.82,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.815,
                to: 46.825,
            },
        ],
        nucleus: '13C',
        solvent: 'toluene- d₈',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.82,
                        assignment: 'CO',
                    },
                ],
                from: 175.815,
                to: 175.825,
            },
            {
                signals: [
                    {
                        delta: 20.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.365000000000002,
                to: 20.375,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204.43,
                        assignment: 'CO',
                    },
                ],
                from: 204.425,
                to: 204.435,
            },
            {
                signals: [
                    {
                        delta: 30.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.135,
                to: 30.145,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 116.02,
                        assignment: 'CN',
                    },
                ],
                from: 116.015,
                to: 116.02499999999999,
            },
            {
                signals: [
                    {
                        delta: 0.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.195,
                to: 0.20500000000000002,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.62,
                        assignment: 'CH',
                    },
                ],
                from: 128.615,
                to: 128.625,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.19,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.185,
                to: 68.195,
            },
            {
                signals: [
                    {
                        delta: 30.47,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.465,
                to: 30.474999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.76,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.75500000000001,
                to: 124.765,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.69,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.685,
                to: 192.695,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.44,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.435,
                to: 96.445,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.79,
                        assignment: 'CH',
                    },
                ],
                from: 77.78500000000001,
                to: 77.795,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.59,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.58500000000001,
                to: 70.595,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.23,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.225,
                to: 27.235,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.59,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.585,
                to: 43.595000000000006,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.455,
                to: 53.465,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.455,
                to: 15.465000000000002,
            },
            {
                signals: [
                    {
                        delta: 65.94,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.935,
                to: 65.945,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.654999999999994,
                to: 58.665,
            },
            {
                signals: [
                    {
                        delta: 70.87,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.86500000000001,
                to: 70.875,
            },
            {
                signals: [
                    {
                        delta: 72.35,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.345,
                to: 72.35499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.13,
                        assignment: 'CH',
                    },
                ],
                from: 162.125,
                to: 162.135,
            },
            {
                signals: [
                    {
                        delta: 35.25,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.245,
                to: 35.255,
            },
            {
                signals: [
                    {
                        delta: 30.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.715,
                to: 30.724999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.16,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.155,
                to: 67.16499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.675,
                to: 58.685,
            },
            {
                signals: [
                    {
                        delta: 72.21,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.205,
                to: 72.21499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.955,
                to: 6.965,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.72,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.715,
                to: 18.724999999999998,
            },
            {
                signals: [
                    {
                        delta: 57.86,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.855,
                to: 57.865,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.56,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.555,
                to: 20.564999999999998,
            },
            {
                signals: [
                    {
                        delta: 170.44,
                        assignment: 'CO',
                    },
                ],
                from: 170.435,
                to: 170.445,
            },
            {
                signals: [
                    {
                        delta: 60.21,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.205,
                to: 60.215,
            },
            {
                signals: [
                    {
                        delta: 14.19,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.184999999999999,
                to: 14.195,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 122.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 122.955,
                to: 122.96499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.34,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.33500000000001,
                to: 64.345,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.22,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.215,
                to: 30.224999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.79,
                        assignment: 'C',
                    },
                ],
                from: 131.785,
                to: 131.795,
            },
            {
                signals: [
                    {
                        delta: 16.95,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.945,
                to: 16.955,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.315,
                to: 14.325000000000001,
            },
            {
                signals: [
                    {
                        delta: 23.04,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.035,
                to: 23.044999999999998,
            },
            {
                signals: [
                    {
                        delta: 31.96,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 31.955000000000002,
                to: 31.965,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.05,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.045,
                to: 2.0549999999999997,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.88,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.875,
                to: 36.885000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.76,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.755,
                to: 135.765,
            },
            {
                signals: [
                    {
                        delta: 122.16,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.155,
                to: 122.16499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.29,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.295,
                to: -4.285,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.97,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.964999999999996,
                to: 49.975,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 61.16,
                        assignment: 'CH₃',
                    },
                ],
                from: 61.154999999999994,
                to: 61.165,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.25,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.245,
                to: 14.255,
            },
            {
                signals: [
                    {
                        delta: 22.72,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.715,
                to: 22.724999999999998,
            },
            {
                signals: [
                    {
                        delta: 34.45,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.445,
                to: 34.455000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.655,
                to: 16.665,
            },
            {
                signals: [
                    {
                        delta: 16.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.595000000000002,
                to: 16.605,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.18,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.175,
                to: 25.185,
            },
            {
                signals: [
                    {
                        delta: 64.23,
                        assignment: 'CH',
                    },
                ],
                from: 64.22500000000001,
                to: 64.235,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.375,
                to: 19.384999999999998,
            },
            {
                signals: [
                    {
                        delta: 115.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.915,
                to: 115.925,
            },
            {
                signals: [
                    {
                        delta: 133.69,
                        assignment: 'CH',
                    },
                ],
                from: 133.685,
                to: 133.695,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.27,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.26500000000001,
                to: 150.275,
            },
            {
                signals: [
                    {
                        delta: 123.58,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.575,
                to: 123.585,
            },
            {
                signals: [
                    {
                        delta: 135.28,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.275,
                to: 135.285,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.78,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.775,
                to: 117.785,
            },
            {
                signals: [
                    {
                        delta: 108.21,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.205,
                to: 108.21499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.86,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.855,
                to: 46.865,
            },
            {
                signals: [
                    {
                        delta: 25.65,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.645,
                to: 25.654999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.375,
                to: 1.3849999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.8,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.795,
                to: 67.80499999999999,
            },
            {
                signals: [
                    {
                        delta: 25.72,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.715,
                to: 25.724999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.095000000000002,
                to: 21.105,
            },
            {
                signals: [
                    {
                        delta: 137.91,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.905,
                to: 137.915,
            },
            {
                signals: [
                    {
                        delta: 129.33,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.32500000000002,
                to: 129.335,
            },
            {
                signals: [
                    {
                        delta: 128.56,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.555,
                to: 128.565,
            },
            {
                signals: [
                    {
                        delta: 125.68,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.67500000000001,
                to: 125.685,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.35,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.344999999999999,
                to: 12.355,
            },
            {
                signals: [
                    {
                        delta: 46.77,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.765,
                to: 46.775000000000006,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₆',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.67,
                        assignment: 'CO',
                    },
                ],
                from: 175.665,
                to: 175.67499999999998,
            },
            {
                signals: [
                    {
                        delta: 20.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.395,
                to: 20.404999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 204.83,
                        assignment: 'CO',
                    },
                ],
                from: 204.82500000000002,
                to: 204.835,
            },
            {
                signals: [
                    {
                        delta: 30.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.115000000000002,
                to: 30.125,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 115.93,
                        assignment: 'CN',
                    },
                ],
                from: 115.92500000000001,
                to: 115.935,
            },
            {
                signals: [
                    {
                        delta: 0.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.625,
                to: 0.635,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.38,
                        assignment: 'CH',
                    },
                ],
                from: 128.375,
                to: 128.385,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.19,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.185,
                to: 68.195,
            },
            {
                signals: [
                    {
                        delta: 31.13,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.125,
                to: 31.134999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 126.08,
                        assignment: 'CO₂',
                    },
                ],
                from: 126.075,
                to: 126.085,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.49,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.485,
                to: 192.495,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.38,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.375,
                to: 96.38499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 77.67,
                        assignment: 'CH',
                    },
                ],
                from: 77.665,
                to: 77.675,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.55,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.545,
                to: 70.55499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 26.99,
                        assignment: 'CH₂',
                    },
                ],
                from: 26.985,
                to: 26.994999999999997,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 43.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 43.595,
                to: 43.605000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 53.54,
                        assignment: 'CH₂',
                    },
                ],
                from: 53.535,
                to: 53.545,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.35,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.344999999999999,
                to: 15.355,
            },
            {
                signals: [
                    {
                        delta: 65.79,
                        assignment: 'CH₂',
                    },
                ],
                from: 65.78500000000001,
                to: 65.795,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.42,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.415,
                to: 58.425000000000004,
            },
            {
                signals: [
                    {
                        delta: 70.56,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.555,
                to: 70.565,
            },
            {
                signals: [
                    {
                        delta: 72.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.065,
                to: 72.07499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.01,
                        assignment: 'CH',
                    },
                ],
                from: 162.005,
                to: 162.015,
            },
            {
                signals: [
                    {
                        delta: 35.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.445,
                to: 35.455000000000005,
            },
            {
                signals: [
                    {
                        delta: 30.71,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.705000000000002,
                to: 30.715,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 66.95,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.94500000000001,
                to: 66.955,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.31,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.305,
                to: 58.315000000000005,
            },
            {
                signals: [
                    {
                        delta: 71.81,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.805,
                to: 71.815,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.905,
                to: 6.915,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.55,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.545,
                to: 18.555,
            },
            {
                signals: [
                    {
                        delta: 57.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.625,
                to: 57.635000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.5,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.495,
                to: 20.505,
            },
            {
                signals: [
                    {
                        delta: 170.2,
                        assignment: 'CO',
                    },
                ],
                from: 170.195,
                to: 170.20499999999998,
            },
            {
                signals: [
                    {
                        delta: 60.06,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.055,
                to: 60.065000000000005,
            },
            {
                signals: [
                    {
                        delta: 14.07,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.065,
                to: 14.075000000000001,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 122.95,
                        assignment: 'CH₂',
                    },
                ],
                from: 122.94500000000001,
                to: 122.955,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.03,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.025,
                to: 64.035,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 30.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 30.105,
                to: 30.115,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.54,
                        assignment: 'C',
                    },
                ],
                from: 131.535,
                to: 131.545,
            },
            {
                signals: [
                    {
                        delta: 16.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.675,
                to: 16.685,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.18,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.174999999999999,
                to: 14.185,
            },
            {
                signals: [
                    {
                        delta: 22.86,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 22.855,
                to: 22.865,
            },
            {
                signals: [
                    {
                        delta: 31.77,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 31.765,
                to: 31.775,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.92,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.915,
                to: 1.9249999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.64,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.635,
                to: 36.645,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.5,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.495,
                to: 135.505,
            },
            {
                signals: [
                    {
                        delta: 121.96,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 121.955,
                to: 121.96499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.33,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.335,
                to: -4.325,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.654999999999994,
                to: 49.665,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 61.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 61.675,
                to: 61.685,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.094999999999999,
                to: 14.105,
            },
            {
                signals: [
                    {
                        delta: 22.54,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.535,
                to: 22.544999999999998,
            },
            {
                signals: [
                    {
                        delta: 34.26,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.254999999999995,
                to: 34.265,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.555,
                to: 16.564999999999998,
            },
            {
                signals: [
                    {
                        delta: 16.48,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.475,
                to: 16.485,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.14,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.135,
                to: 25.145,
            },
            {
                signals: [
                    {
                        delta: 64.18,
                        assignment: 'CH',
                    },
                ],
                from: 64.17500000000001,
                to: 64.185,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.315,
                to: 19.325,
            },
            {
                signals: [
                    {
                        delta: 115.86,
                        assignment: 'CH₂',
                    },
                ],
                from: 115.855,
                to: 115.865,
            },
            {
                signals: [
                    {
                        delta: 133.57,
                        assignment: 'CH',
                    },
                ],
                from: 133.565,
                to: 133.575,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.93,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.925,
                to: 149.935,
            },
            {
                signals: [
                    {
                        delta: 123.49,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.485,
                to: 123.49499999999999,
            },
            {
                signals: [
                    {
                        delta: 135.32,
                        assignment: 'CH(4)',
                    },
                ],
                from: 135.315,
                to: 135.325,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.65,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.64500000000001,
                to: 117.655,
            },
            {
                signals: [
                    {
                        delta: 108.03,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.025,
                to: 108.035,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.75,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.745,
                to: 46.755,
            },
            {
                signals: [
                    {
                        delta: 25.59,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.585,
                to: 25.595,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.09,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.0850000000000002,
                to: 1.095,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.64,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.635,
                to: 67.645,
            },
            {
                signals: [
                    {
                        delta: 25.68,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.675,
                to: 25.685,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.23,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.225,
                to: 21.235,
            },
            {
                signals: [
                    {
                        delta: 137.65,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.645,
                to: 137.655,
            },
            {
                signals: [
                    {
                        delta: 129.12,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.115,
                to: 129.125,
            },
            {
                signals: [
                    {
                        delta: 128.31,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.305,
                to: 128.315,
            },
            {
                signals: [
                    {
                        delta: 125.43,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.42500000000001,
                to: 125.435,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.87,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.864999999999998,
                to: 11.875,
            },
            {
                signals: [
                    {
                        delta: 46.36,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.355,
                to: 46.365,
            },
        ],
        nucleus: '13C',
        solvent: 'C₆D₅Cl',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 172.31,
                        assignment: 'CO',
                    },
                ],
                from: 172.305,
                to: 172.315,
            },
            {
                signals: [
                    {
                        delta: 20.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.505000000000003,
                to: 20.515,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 205.87,
                        assignment: 'CO',
                    },
                ],
                from: 205.865,
                to: 205.875,
            },
            {
                signals: [
                    {
                        delta: 30.6,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.595000000000002,
                to: 30.605,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.6,
                        assignment: 'CN',
                    },
                ],
                from: 117.595,
                to: 117.60499999999999,
            },
            {
                signals: [
                    {
                        delta: 1.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.1150000000000002,
                to: 1.125,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.15,
                        assignment: 'CH',
                    },
                ],
                from: 129.145,
                to: 129.155,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.13,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.125,
                to: 68.13499999999999,
            },
            {
                signals: [
                    {
                        delta: 30.72,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.715,
                to: 30.724999999999998,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.81,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.805,
                to: 125.815,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.58,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.57500000000002,
                to: 193.585,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.65,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.64500000000001,
                to: 96.655,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.19,
                        assignment: 'CH',
                    },
                ],
                from: 79.185,
                to: 79.195,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.245,
                to: 71.255,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.51,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.505000000000003,
                to: 27.515,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.245,
                to: 45.255,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.95,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.945,
                to: 54.955000000000005,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.78,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.774999999999999,
                to: 15.785,
            },
            {
                signals: [
                    {
                        delta: 66.12,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.11500000000001,
                to: 66.125,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.77,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.765,
                to: 58.775000000000006,
            },
            {
                signals: [
                    {
                        delta: 71.03,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.025,
                to: 71.035,
            },
            {
                signals: [
                    {
                        delta: 72.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.625,
                to: 72.63499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.79,
                        assignment: 'CH',
                    },
                ],
                from: 162.785,
                to: 162.795,
            },
            {
                signals: [
                    {
                        delta: 36.15,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.144999999999996,
                to: 36.155,
            },
            {
                signals: [
                    {
                        delta: 31.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.025000000000002,
                to: 31.035,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.6,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.595,
                to: 67.60499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.445,
                to: 58.455000000000005,
            },
            {
                signals: [
                    {
                        delta: 72.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.465,
                to: 72.475,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.88,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.875,
                to: 6.885,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.885,
                to: 18.895,
            },
            {
                signals: [
                    {
                        delta: 57.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.714999999999996,
                to: 57.725,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.83,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.825,
                to: 20.834999999999997,
            },
            {
                signals: [
                    {
                        delta: 170.96,
                        assignment: 'CO',
                    },
                ],
                from: 170.955,
                to: 170.965,
            },
            {
                signals: [
                    {
                        delta: 60.56,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.555,
                to: 60.565000000000005,
            },
            {
                signals: [
                    {
                        delta: 14.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.495,
                to: 14.505,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.465,
                to: 123.475,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.26,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.25500000000001,
                to: 64.265,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.22,
                        assignment: 'C',
                    },
                ],
                from: 132.215,
                to: 132.225,
            },
            {
                signals: [
                    {
                        delta: 16.86,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.855,
                to: 16.865,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.34,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.334999999999999,
                to: 14.345,
            },
            {
                signals: [
                    {
                        delta: 23.28,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.275000000000002,
                to: 23.285,
            },
            {
                signals: [
                    {
                        delta: 32.3,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.294999999999995,
                to: 32.305,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.01,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.005,
                to: 2.0149999999999997,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37.04,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.035,
                to: 37.045,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.89,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.885,
                to: 135.89499999999998,
            },
            {
                signals: [
                    {
                        delta: 122.31,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.305,
                to: 122.315,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -5.33,
                        assignment: 'CH₄',
                    },
                ],
                from: -5.335,
                to: -5.325,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.77,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.765,
                to: 49.775000000000006,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.21,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.205,
                to: 63.215,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.29,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.284999999999998,
                to: 14.295,
            },
            {
                signals: [
                    {
                        delta: 22.98,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 22.975,
                to: 22.985,
            },
            {
                signals: [
                    {
                        delta: 34.83,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.824999999999996,
                to: 34.835,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.68,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.675,
                to: 16.685,
            },
            {
                signals: [
                    {
                        delta: 16.78,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.775000000000002,
                to: 16.785,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.665000000000003,
                to: 25.675,
            },
            {
                signals: [
                    {
                        delta: 63.85,
                        assignment: 'CH',
                    },
                ],
                from: 63.845,
                to: 63.855000000000004,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.42,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.415000000000003,
                to: 19.425,
            },
            {
                signals: [
                    {
                        delta: 116.03,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.025,
                to: 116.035,
            },
            {
                signals: [
                    {
                        delta: 134.34,
                        assignment: 'CH',
                    },
                ],
                from: 134.335,
                to: 134.345,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.67,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.665,
                to: 150.67499999999998,
            },
            {
                signals: [
                    {
                        delta: 124.57,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 124.565,
                to: 124.57499999999999,
            },
            {
                signals: [
                    {
                        delta: 136.56,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.555,
                to: 136.565,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.98,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.97500000000001,
                to: 117.985,
            },
            {
                signals: [
                    {
                        delta: 108.04,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.03500000000001,
                to: 108.045,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.395,
                to: 1.4049999999999998,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.07,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.065,
                to: 68.07499999999999,
            },
            {
                signals: [
                    {
                        delta: 26.15,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.145,
                to: 26.154999999999998,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.455000000000002,
                to: 21.465,
            },
            {
                signals: [
                    {
                        delta: 138.48,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.475,
                to: 138.48499999999999,
            },
            {
                signals: [
                    {
                        delta: 129.76,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.755,
                to: 129.765,
            },
            {
                signals: [
                    {
                        delta: 129.03,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.025,
                to: 129.035,
            },
            {
                signals: [
                    {
                        delta: 126.12,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.11500000000001,
                to: 126.125,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.485,
                to: 12.495000000000001,
            },
            {
                signals: [
                    {
                        delta: 47.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.065,
                to: 47.075,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂CO',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 171.93,
                        assignment: 'CO',
                    },
                ],
                from: 171.925,
                to: 171.935,
            },
            {
                signals: [
                    {
                        delta: 20.95,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.945,
                to: 20.955,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 206.31,
                        assignment: 'CO',
                    },
                ],
                from: 206.305,
                to: 206.315,
            },
            {
                signals: [
                    {
                        delta: 30.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.555,
                to: 30.564999999999998,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.91,
                        assignment: 'CN',
                    },
                ],
                from: 117.905,
                to: 117.91499999999999,
            },
            {
                signals: [
                    {
                        delta: 1.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.0250000000000001,
                to: 1.035,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 128.3,
                        assignment: 'CH',
                    },
                ],
                from: 128.29500000000002,
                to: 128.305,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 66.88,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 66.875,
                to: 66.88499999999999,
            },
            {
                signals: [
                    {
                        delta: 30.38,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.375,
                to: 30.384999999999998,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.21,
                        assignment: 'CO₂',
                    },
                ],
                from: 124.205,
                to: 124.21499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 192.63,
                        assignment: 'CS₂',
                    },
                ],
                from: 192.625,
                to: 192.635,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 95.44,
                        assignment: 'CCl₄',
                    },
                ],
                from: 95.435,
                to: 95.445,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.16,
                        assignment: 'CH',
                    },
                ],
                from: 79.155,
                to: 79.16499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.85,
                        assignment: 'CH₂',
                    },
                ],
                from: 69.845,
                to: 69.85499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 26.33,
                        assignment: 'CH₂',
                    },
                ],
                from: 26.325,
                to: 26.334999999999997,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.02,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.015,
                to: 45.025000000000006,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.84,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.835,
                to: 54.845000000000006,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.12,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.114999999999998,
                to: 15.125,
            },
            {
                signals: [
                    {
                        delta: 62.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.044999999999995,
                to: 62.055,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 57.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 57.974999999999994,
                to: 57.985,
            },
            {
                signals: [
                    {
                        delta: 69.54,
                        assignment: 'CH₂',
                    },
                ],
                from: 69.53500000000001,
                to: 69.545,
            },
            {
                signals: [
                    {
                        delta: 71.25,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.245,
                to: 71.255,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 162.29,
                        assignment: 'CH',
                    },
                ],
                from: 162.285,
                to: 162.295,
            },
            {
                signals: [
                    {
                        delta: 35.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 35.724999999999994,
                to: 35.735,
            },
            {
                signals: [
                    {
                        delta: 30.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.725,
                to: 30.735,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 66.36,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.355,
                to: 66.365,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.025,
                to: 58.035000000000004,
            },
            {
                signals: [
                    {
                        delta: 71.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.165,
                to: 71.175,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.61,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.605,
                to: 6.615,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.505000000000003,
                to: 18.515,
            },
            {
                signals: [
                    {
                        delta: 56.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 56.065,
                to: 56.075,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.68,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.675,
                to: 20.685,
            },
            {
                signals: [
                    {
                        delta: 170.31,
                        assignment: 'CO',
                    },
                ],
                from: 170.305,
                to: 170.315,
            },
            {
                signals: [
                    {
                        delta: 59.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 59.735,
                to: 59.745000000000005,
            },
            {
                signals: [
                    {
                        delta: 14.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.395,
                to: 14.405000000000001,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.52,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.515,
                to: 123.52499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 62.76,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.754999999999995,
                to: 62.765,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 131.1,
                        assignment: 'C',
                    },
                ],
                from: 131.095,
                to: 131.105,
            },
            {
                signals: [
                    {
                        delta: 16.6,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.595000000000002,
                to: 16.605,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 13.88,
                        assignment: 'CH₃',
                    },
                ],
                from: 13.875,
                to: 13.885000000000002,
            },
            {
                signals: [
                    {
                        delta: 22.05,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 22.045,
                to: 22.055,
            },
            {
                signals: [
                    {
                        delta: 30.95,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 30.945,
                to: 30.955,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.955,
                to: 1.9649999999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.42,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.415,
                to: 36.425000000000004,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 135.15,
                        assignment: 'CH(2)',
                    },
                ],
                from: 135.145,
                to: 135.155,
            },
            {
                signals: [
                    {
                        delta: 121.55,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 121.545,
                to: 121.55499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.01,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.015,
                to: -4.005,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 48.59,
                        assignment: 'CH₃',
                    },
                ],
                from: 48.585,
                to: 48.595000000000006,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.28,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.275,
                to: 63.285000000000004,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 13.28,
                        assignment: 'CH₃',
                    },
                ],
                from: 13.274999999999999,
                to: 13.285,
            },
            {
                signals: [
                    {
                        delta: 21.7,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 21.695,
                to: 21.705,
            },
            {
                signals: [
                    {
                        delta: 33.48,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 33.474999999999994,
                to: 33.485,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.34,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.335,
                to: 16.345,
            },
            {
                signals: [
                    {
                        delta: 15.67,
                        assignment: 'CH₂',
                    },
                ],
                from: 15.665,
                to: 15.675,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.43,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.425,
                to: 25.435,
            },
            {
                signals: [
                    {
                        delta: 64.92,
                        assignment: 'CH',
                    },
                ],
                from: 64.915,
                to: 64.925,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.2,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.195,
                to: 19.205,
            },
            {
                signals: [
                    {
                        delta: 116.07,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.065,
                to: 116.07499999999999,
            },
            {
                signals: [
                    {
                        delta: 133.55,
                        assignment: 'CH',
                    },
                ],
                from: 133.54500000000002,
                to: 133.555,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.58,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.57500000000002,
                to: 149.585,
            },
            {
                signals: [
                    {
                        delta: 123.84,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 123.83500000000001,
                to: 123.845,
            },
            {
                signals: [
                    {
                        delta: 136.05,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.04500000000002,
                to: 136.055,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 117.32,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 117.315,
                to: 117.32499999999999,
            },
            {
                signals: [
                    {
                        delta: 107.07,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.065,
                to: 107.07499999999999,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.51,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.504999999999995,
                to: 46.515,
            },
            {
                signals: [
                    {
                        delta: 25.26,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.255000000000003,
                to: 25.265,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.03,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 67.025,
                to: 67.035,
            },
            {
                signals: [
                    {
                        delta: 25.14,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.135,
                to: 25.145,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.985,
                to: 20.994999999999997,
            },
            {
                signals: [
                    {
                        delta: 137.35,
                        assignment: 'C(1)',
                    },
                ],
                from: 137.345,
                to: 137.355,
            },
            {
                signals: [
                    {
                        delta: 128.88,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 128.875,
                to: 128.885,
            },
            {
                signals: [
                    {
                        delta: 128.18,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 128.175,
                to: 128.185,
            },
            {
                signals: [
                    {
                        delta: 125.29,
                        assignment: 'CH(4)',
                    },
                ],
                from: 125.28500000000001,
                to: 125.295,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.74,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.735,
                to: 11.745000000000001,
            },
            {
                signals: [
                    {
                        delta: 45.74,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.735,
                to: 45.745000000000005,
            },
        ],
        nucleus: '13C',
        solvent: '(CD₃)₂SO',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 173.21,
                        assignment: 'CO',
                    },
                ],
                from: 173.205,
                to: 173.215,
            },
            {
                signals: [
                    {
                        delta: 20.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.725,
                to: 20.735,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 207.43,
                        assignment: 'CO',
                    },
                ],
                from: 207.425,
                to: 207.435,
            },
            {
                signals: [
                    {
                        delta: 30.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.905,
                to: 30.915,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.26,
                        assignment: 'CN',
                    },
                ],
                from: 118.25500000000001,
                to: 118.265,
            },
            {
                signals: [
                    {
                        delta: 1.79,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.7850000000000001,
                to: 1.795,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.32,
                        assignment: 'CH',
                    },
                ],
                from: 129.315,
                to: 129.325,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.74,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 68.735,
                to: 68.74499999999999,
            },
            {
                signals: [
                    {
                        delta: 30.68,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.675,
                to: 30.685,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 125.89,
                        assignment: 'CO₂',
                    },
                ],
                from: 125.885,
                to: 125.895,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.6,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.595,
                to: 193.605,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.68,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.67500000000001,
                to: 96.685,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.17,
                        assignment: 'CH',
                    },
                ],
                from: 79.165,
                to: 79.175,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.22,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.215,
                to: 71.225,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.625,
                to: 27.634999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.54,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.535,
                to: 45.545,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 55.32,
                        assignment: 'CH₂',
                    },
                ],
                from: 55.315,
                to: 55.325,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.625,
                to: 15.635000000000002,
            },
            {
                signals: [
                    {
                        delta: 66.32,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.315,
                to: 66.32499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.894999999999996,
                to: 58.905,
            },
            {
                signals: [
                    {
                        delta: 70.99,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.985,
                to: 70.99499999999999,
            },
            {
                signals: [
                    {
                        delta: 72.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.625,
                to: 72.63499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 163.31,
                        assignment: 'CH',
                    },
                ],
                from: 163.305,
                to: 163.315,
            },
            {
                signals: [
                    {
                        delta: 36.57,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.565,
                to: 36.575,
            },
            {
                signals: [
                    {
                        delta: 31.32,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.315,
                to: 31.325,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.715,
                to: 67.725,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.885,
                to: 58.895,
            },
            {
                signals: [
                    {
                        delta: 72.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.465,
                to: 72.475,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.985,
                to: 6.995,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.8,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.795,
                to: 18.805,
            },
            {
                signals: [
                    {
                        delta: 57.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 57.955,
                to: 57.965,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.16,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.155,
                to: 21.165,
            },
            {
                signals: [
                    {
                        delta: 171.68,
                        assignment: 'CO',
                    },
                ],
                from: 171.675,
                to: 171.685,
            },
            {
                signals: [
                    {
                        delta: 60.98,
                        assignment: 'CH₂',
                    },
                ],
                from: 60.974999999999994,
                to: 60.985,
            },
            {
                signals: [
                    {
                        delta: 14.54,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.534999999999998,
                to: 14.545,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.69,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.685,
                to: 123.695,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.22,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.215,
                to: 64.225,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.61,
                        assignment: 'C',
                    },
                ],
                from: 132.60500000000002,
                to: 132.615,
            },
            {
                signals: [
                    {
                        delta: 16.94,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.935000000000002,
                to: 16.945,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.43,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.424999999999999,
                to: 14.435,
            },
            {
                signals: [
                    {
                        delta: 23.4,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.395,
                to: 23.404999999999998,
            },
            {
                signals: [
                    {
                        delta: 32.36,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.355,
                to: 32.365,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.07,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.065,
                to: 2.0749999999999997,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.095,
                to: 37.105000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.33,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.32500000000002,
                to: 136.335,
            },
            {
                signals: [
                    {
                        delta: 122.78,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.775,
                to: 122.785,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.61,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.615,
                to: -4.605,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.894999999999996,
                to: 49.905,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.66,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.654999999999994,
                to: 63.665,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.37,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.364999999999998,
                to: 14.375,
            },
            {
                signals: [
                    {
                        delta: 23.08,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 23.075,
                to: 23.084999999999997,
            },
            {
                signals: [
                    {
                        delta: 34.89,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 34.885,
                to: 34.895,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.73,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.725,
                to: 16.735,
            },
            {
                signals: [
                    {
                        delta: 16.91,
                        assignment: 'CH₂',
                    },
                ],
                from: 16.905,
                to: 16.915,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.55,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.545,
                to: 25.555,
            },
            {
                signals: [
                    {
                        delta: 64.3,
                        assignment: 'CH',
                    },
                ],
                from: 64.295,
                to: 64.30499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.48,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.475,
                to: 19.485,
            },
            {
                signals: [
                    {
                        delta: 116.12,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.11500000000001,
                to: 116.125,
            },
            {
                signals: [
                    {
                        delta: 134.78,
                        assignment: 'CH',
                    },
                ],
                from: 134.775,
                to: 134.785,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.76,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.755,
                to: 150.765,
            },
            {
                signals: [
                    {
                        delta: 127.76,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 127.75500000000001,
                to: 127.765,
            },
            {
                signals: [
                    {
                        delta: 136.89,
                        assignment: 'CH(4)',
                    },
                ],
                from: 136.885,
                to: 136.89499999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.47,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 118.465,
                to: 118.475,
            },
            {
                signals: [
                    {
                        delta: 108.31,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.305,
                to: 108.315,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.57,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.565,
                to: 47.575,
            },
            {
                signals: [
                    {
                        delta: 26.34,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.335,
                to: 26.345,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.33,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.325,
                to: 68.335,
            },
            {
                signals: [
                    {
                        delta: 26.27,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.265,
                to: 26.275,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.495,
                to: 21.505,
            },
            {
                signals: [
                    {
                        delta: 138.9,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.895,
                to: 138.905,
            },
            {
                signals: [
                    {
                        delta: 129.94,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.935,
                to: 129.945,
            },
            {
                signals: [
                    {
                        delta: 129.23,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.225,
                to: 129.23499999999999,
            },
            {
                signals: [
                    {
                        delta: 126.28,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.275,
                to: 126.285,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 12.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 12.375,
                to: 12.385000000000002,
            },
            {
                signals: [
                    {
                        delta: 47.1,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.095,
                to: 47.105000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃CN',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 177.96,
                        assignment: 'CO',
                    },
                ],
                from: 177.955,
                to: 177.965,
            },
            {
                signals: [
                    {
                        delta: 20.91,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.905,
                to: 20.915,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 32.35,
                        assignment: 'CO',
                    },
                ],
                from: 32.345,
                to: 32.355000000000004,
            },
            {
                signals: [
                    {
                        delta: 214.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 214.975,
                to: 214.98499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.95,
                        assignment: 'CN',
                    },
                ],
                from: 118.94500000000001,
                to: 118.955,
            },
            {
                signals: [
                    {
                        delta: 1,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.995,
                to: 1.005,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.84,
                        assignment: 'CH',
                    },
                ],
                from: 129.835,
                to: 129.845,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 72.35,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 72.345,
                to: 72.35499999999999,
            },
            {
                signals: [
                    {
                        delta: 31.07,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 31.065,
                to: 31.075,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 126.92,
                        assignment: 'CO₂',
                    },
                ],
                from: 126.915,
                to: 126.925,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 196.26,
                        assignment: 'CS₂',
                    },
                ],
                from: 196.255,
                to: 196.265,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 97.74,
                        assignment: 'CCl₄',
                    },
                ],
                from: 97.735,
                to: 97.74499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 78.83,
                        assignment: 'CH',
                    },
                ],
                from: 78.825,
                to: 78.835,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.8,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.795,
                to: 70.80499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 28.34,
                        assignment: 'CH₂',
                    },
                ],
                from: 28.335,
                to: 28.345,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.28,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.275,
                to: 45.285000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.455,
                to: 54.465,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.33,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.325,
                to: 15.335,
            },
            {
                signals: [
                    {
                        delta: 67.55,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.545,
                to: 67.55499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.394999999999996,
                to: 59.405,
            },
            {
                signals: [
                    {
                        delta: 73.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 73.045,
                to: 73.05499999999999,
            },
            {
                signals: [
                    {
                        delta: 71.33,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.325,
                to: 71.335,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 166.01,
                        assignment: 'CH',
                    },
                ],
                from: 166.005,
                to: 166.015,
            },
            {
                signals: [
                    {
                        delta: 37.76,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.754999999999995,
                to: 37.765,
            },
            {
                signals: [
                    {
                        delta: 30.96,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.955000000000002,
                to: 30.965,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.52,
                        assignment: 'CH₂',
                    },
                ],
                from: 68.515,
                to: 68.52499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.52,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.515,
                to: 59.525000000000006,
            },
            {
                signals: [
                    {
                        delta: 72.87,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.86500000000001,
                to: 72.875,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 7.01,
                        assignment: 'CH₃',
                    },
                ],
                from: 7.005,
                to: 7.015,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.11,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.105,
                to: 18.115,
            },
            {
                signals: [
                    {
                        delta: 59.68,
                        assignment: 'CH₂',
                    },
                ],
                from: 59.675,
                to: 59.685,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.18,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.175,
                to: 21.185,
            },
            {
                signals: [
                    {
                        delta: 175.55,
                        assignment: 'CO',
                    },
                ],
                from: 175.54500000000002,
                to: 175.555,
            },
            {
                signals: [
                    {
                        delta: 62.7,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.695,
                to: 62.705000000000005,
            },
            {
                signals: [
                    {
                        delta: 14.36,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.354999999999999,
                to: 14.365,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 124.08,
                        assignment: 'CH₂',
                    },
                ],
                from: 124.075,
                to: 124.085,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.87,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.86500000000001,
                to: 64.875,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 134.04,
                        assignment: 'C',
                    },
                ],
                from: 134.035,
                to: 134.045,
            },
            {
                signals: [
                    {
                        delta: 17.04,
                        assignment: 'CH₃',
                    },
                ],
                from: 17.035,
                to: 17.044999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.625,
                to: 14.635000000000002,
            },
            {
                signals: [
                    {
                        delta: 24.06,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 24.055,
                to: 24.064999999999998,
            },
            {
                signals: [
                    {
                        delta: 33.17,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 33.165,
                to: 33.175000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.09,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.085,
                to: 2.0949999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37.21,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.205,
                to: 37.215,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.58,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.57500000000002,
                to: 136.585,
            },
            {
                signals: [
                    {
                        delta: 122.93,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.92500000000001,
                to: 122.935,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -5.88,
                        assignment: 'CH₄',
                    },
                ],
                from: -5.885,
                to: -5.875,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 50.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 50.665,
                to: 50.675000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.17,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.165,
                to: 63.175000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.54,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.534999999999998,
                to: 14.545,
            },
            {
                signals: [
                    {
                        delta: 23.75,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 23.745,
                to: 23.755,
            },
            {
                signals: [
                    {
                        delta: 35.76,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 35.754999999999995,
                to: 35.765,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.93,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.925,
                to: 16.935,
            },
            {
                signals: [
                    {
                        delta: 17.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 17.455000000000002,
                to: 17.465,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.21,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.205000000000002,
                to: 25.215,
            },
            {
                signals: [
                    {
                        delta: 66.69,
                        assignment: 'CH',
                    },
                ],
                from: 66.685,
                to: 66.695,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.63,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.625,
                to: 19.634999999999998,
            },
            {
                signals: [
                    {
                        delta: 116.38,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.375,
                to: 116.38499999999999,
            },
            {
                signals: [
                    {
                        delta: 136,
                        assignment: 'CH',
                    },
                ],
                from: 135.995,
                to: 136.005,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.76,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.755,
                to: 149.765,
            },
            {
                signals: [
                    {
                        delta: 126.27,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 126.265,
                to: 126.27499999999999,
            },
            {
                signals: [
                    {
                        delta: 139.62,
                        assignment: 'CH(4)',
                    },
                ],
                from: 139.615,
                to: 139.625,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 119.61,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 119.605,
                to: 119.615,
            },
            {
                signals: [
                    {
                        delta: 108.85,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.845,
                to: 108.85499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.43,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.425,
                to: 47.435,
            },
            {
                signals: [
                    {
                        delta: 25.73,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.725,
                to: 25.735,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.87,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.865,
                to: 2.875,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.53,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 69.525,
                to: 69.535,
            },
            {
                signals: [
                    {
                        delta: 26.69,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.685000000000002,
                to: 26.695,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.62,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.615000000000002,
                to: 21.625,
            },
            {
                signals: [
                    {
                        delta: 139.92,
                        assignment: 'C(1)',
                    },
                ],
                from: 139.915,
                to: 139.92499999999998,
            },
            {
                signals: [
                    {
                        delta: 130.58,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 130.57500000000002,
                to: 130.585,
            },
            {
                signals: [
                    {
                        delta: 129.79,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.785,
                to: 129.795,
            },
            {
                signals: [
                    {
                        delta: 126.82,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.815,
                to: 126.82499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 9.51,
                        assignment: 'CH₃',
                    },
                ],
                from: 9.504999999999999,
                to: 9.515,
            },
            {
                signals: [
                    {
                        delta: 48.45,
                        assignment: 'CH₂',
                    },
                ],
                from: 48.445,
                to: 48.455000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'TFE-d₃',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 175.11,
                        assignment: 'CO',
                    },
                ],
                from: 175.10500000000002,
                to: 175.115,
            },
            {
                signals: [
                    {
                        delta: 20.56,
                        assignment: 'CH₃',
                    },
                ],
                from: 20.555,
                to: 20.564999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 209.67,
                        assignment: 'CO',
                    },
                ],
                from: 209.665,
                to: 209.67499999999998,
            },
            {
                signals: [
                    {
                        delta: 30.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.665000000000003,
                to: 30.675,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.06,
                        assignment: 'CN',
                    },
                ],
                from: 118.055,
                to: 118.065,
            },
            {
                signals: [
                    {
                        delta: 0.85,
                        assignment: 'CH₃',
                    },
                ],
                from: 0.845,
                to: 0.855,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 129.34,
                        assignment: 'CH',
                    },
                ],
                from: 129.335,
                to: 129.345,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 69.4,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 69.39500000000001,
                to: 69.405,
            },
            {
                signals: [
                    {
                        delta: 30.91,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.905,
                to: 30.915,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [
            {
                signals: [
                    {
                        delta: 126.31,
                        assignment: 'CO₂',
                    },
                ],
                from: 126.305,
                to: 126.315,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 193.82,
                        assignment: 'CS₂',
                    },
                ],
                from: 193.815,
                to: 193.825,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 97.21,
                        assignment: 'CCl₄',
                    },
                ],
                from: 97.205,
                to: 97.21499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 79.44,
                        assignment: 'CH',
                    },
                ],
                from: 79.435,
                to: 79.445,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 71.47,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.465,
                to: 71.475,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 27.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 27.955000000000002,
                to: 27.965,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 45.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 45.105,
                to: 45.115,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [
            {
                signals: [
                    {
                        delta: 54.78,
                        assignment: 'CH₂',
                    },
                ],
                from: 54.775,
                to: 54.785000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 15.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 15.455,
                to: 15.465000000000002,
            },
            {
                signals: [
                    {
                        delta: 66.88,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.875,
                to: 66.88499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.06,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.055,
                to: 59.065000000000005,
            },
            {
                signals: [
                    {
                        delta: 71.33,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.325,
                to: 71.335,
            },
            {
                signals: [
                    {
                        delta: 72.92,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.915,
                to: 72.925,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 164.73,
                        assignment: 'CH',
                    },
                ],
                from: 164.725,
                to: 164.73499999999999,
            },
            {
                signals: [
                    {
                        delta: 36.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.885,
                to: 36.895,
            },
            {
                signals: [
                    {
                        delta: 31.61,
                        assignment: 'CH₃',
                    },
                ],
                from: 31.605,
                to: 31.615,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.11,
                        assignment: 'CH₂',
                    },
                ],
                from: 68.105,
                to: 68.115,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 59.06,
                        assignment: 'CH₃',
                    },
                ],
                from: 59.055,
                to: 59.065000000000005,
            },
            {
                signals: [
                    {
                        delta: 72.72,
                        assignment: 'CH₂',
                    },
                ],
                from: 72.715,
                to: 72.725,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 6.98,
                        assignment: 'CH₃',
                    },
                ],
                from: 6.9750000000000005,
                to: 6.985,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 18.4,
                        assignment: 'CH₃',
                    },
                ],
                from: 18.395,
                to: 18.404999999999998,
            },
            {
                signals: [
                    {
                        delta: 58.26,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.254999999999995,
                to: 58.265,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 20.88,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 20.875,
                to: 20.884999999999998,
            },
            {
                signals: [
                    {
                        delta: 172.89,
                        assignment: 'CO',
                    },
                ],
                from: 172.885,
                to: 172.89499999999998,
            },
            {
                signals: [
                    {
                        delta: 61.5,
                        assignment: 'CH₂',
                    },
                ],
                from: 61.495,
                to: 61.505,
            },
            {
                signals: [
                    {
                        delta: 14.49,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.485,
                to: 14.495000000000001,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 123.46,
                        assignment: 'CH₂',
                    },
                ],
                from: 123.455,
                to: 123.46499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 64.3,
                        assignment: 'CH₂',
                    },
                ],
                from: 64.295,
                to: 64.30499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 132.53,
                        assignment: 'C',
                    },
                ],
                from: 132.525,
                to: 132.535,
            },
            {
                signals: [
                    {
                        delta: 16.9,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.895,
                to: 16.904999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.45,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.444999999999999,
                to: 14.455,
            },
            {
                signals: [
                    {
                        delta: 23.68,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 23.675,
                to: 23.685,
            },
            {
                signals: [
                    {
                        delta: 32.73,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 32.724999999999994,
                to: 32.735,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 1.99,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.985,
                to: 1.9949999999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 37,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.995,
                to: 37.005,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.31,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.305,
                to: 136.315,
            },
            {
                signals: [
                    {
                        delta: 122.6,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.595,
                to: 122.60499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [
            {
                signals: [
                    {
                        delta: -4.9,
                        assignment: 'CH₄',
                    },
                ],
                from: -4.905,
                to: -4.8950000000000005,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.86,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.855,
                to: 49.865,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.08,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.074999999999996,
                to: 63.085,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.39,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.385,
                to: 14.395000000000001,
            },
            {
                signals: [
                    {
                        delta: 23.38,
                        assignment: 'CH₂(2,4)',
                    },
                ],
                from: 23.375,
                to: 23.384999999999998,
            },
            {
                signals: [
                    {
                        delta: 35.3,
                        assignment: 'CH₂(3)',
                    },
                ],
                from: 35.294999999999995,
                to: 35.305,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 16.8,
                        assignment: 'CH₃',
                    },
                ],
                from: 16.795,
                to: 16.805,
            },
            {
                signals: [
                    {
                        delta: 17.19,
                        assignment: 'CH₂',
                    },
                ],
                from: 17.185000000000002,
                to: 17.195,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 25.27,
                        assignment: 'CH₃',
                    },
                ],
                from: 25.265,
                to: 25.275,
            },
            {
                signals: [
                    {
                        delta: 64.71,
                        assignment: 'CH',
                    },
                ],
                from: 64.705,
                to: 64.71499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [
            {
                signals: [
                    {
                        delta: 19.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 19.495,
                to: 19.505,
            },
            {
                signals: [
                    {
                        delta: 116.04,
                        assignment: 'CH₂',
                    },
                ],
                from: 116.03500000000001,
                to: 116.045,
            },
            {
                signals: [
                    {
                        delta: 134.61,
                        assignment: 'CH',
                    },
                ],
                from: 134.60500000000002,
                to: 134.615,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 150.07,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 150.065,
                to: 150.075,
            },
            {
                signals: [
                    {
                        delta: 125.53,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 125.525,
                to: 125.535,
            },
            {
                signals: [
                    {
                        delta: 138.35,
                        assignment: 'CH(4)',
                    },
                ],
                from: 138.345,
                to: 138.355,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 118.28,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 118.275,
                to: 118.285,
            },
            {
                signals: [
                    {
                        delta: 108.11,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 108.105,
                to: 108.115,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 47.23,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 47.224999999999994,
                to: 47.235,
            },
            {
                signals: [
                    {
                        delta: 26.29,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.285,
                to: 26.294999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.1,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.095,
                to: 2.105,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.83,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.825,
                to: 68.835,
            },
            {
                signals: [
                    {
                        delta: 26.48,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 26.475,
                to: 26.485,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.495,
                to: 21.505,
            },
            {
                signals: [
                    {
                        delta: 138.85,
                        assignment: 'C(1)',
                    },
                ],
                from: 138.845,
                to: 138.855,
            },
            {
                signals: [
                    {
                        delta: 129.91,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 129.905,
                to: 129.915,
            },
            {
                signals: [
                    {
                        delta: 129.2,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 129.195,
                to: 129.20499999999998,
            },
            {
                signals: [
                    {
                        delta: 126.29,
                        assignment: 'CH(4)',
                    },
                ],
                from: 126.28500000000001,
                to: 126.295,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 11.09,
                        assignment: 'CH₃',
                    },
                ],
                from: 11.084999999999999,
                to: 11.095,
            },
            {
                signals: [
                    {
                        delta: 46.96,
                        assignment: 'CH₂',
                    },
                ],
                from: 46.955,
                to: 46.965,
            },
        ],
        nucleus: '13C',
        solvent: 'CD₃OD',
    },
    {
        names: ['acetic acid'],
        smiles: 'CC(=O)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 177.21,
                        assignment: 'CO',
                    },
                ],
                from: 177.205,
                to: 177.215,
            },
            {
                signals: [
                    {
                        delta: 21.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 21.025000000000002,
                to: 21.035,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['acetone'],
        smiles: 'CC(=O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 215.94,
                        assignment: 'CO',
                    },
                ],
                from: 215.935,
                to: 215.945,
            },
            {
                signals: [
                    {
                        delta: 30.89,
                        assignment: 'CH₃',
                    },
                ],
                from: 30.885,
                to: 30.895,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['acetonitrile'],
        smiles: 'CC#N',
        ranges: [
            {
                signals: [
                    {
                        delta: 119.68,
                        assignment: 'CN',
                    },
                ],
                from: 119.67500000000001,
                to: 119.685,
            },
            {
                signals: [
                    {
                        delta: 1.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 1.465,
                to: 1.4749999999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['benzene'],
        smiles: 'c1ccccc1',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['tert -butyl alcohol'],
        smiles: 'CC(C)(C)O',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.36,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 70.355,
                to: 70.365,
            },
            {
                signals: [
                    {
                        delta: 30.29,
                        assignment: '(CH₃)₃C',
                    },
                ],
                from: 30.285,
                to: 30.294999999999998,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['carbon dioxide'],
        smiles: 'O=C=O',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['carbon disulfide'],
        smiles: 'S=C=S',
        ranges: [
            {
                signals: [
                    {
                        delta: 197.25,
                        assignment: 'CS₂',
                    },
                ],
                from: 197.245,
                to: 197.255,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['carbon tetrachloride'],
        smiles: 'ClC(Cl)(Cl)Cl',
        ranges: [
            {
                signals: [
                    {
                        delta: 96.73,
                        assignment: 'CCl₄',
                    },
                ],
                from: 96.72500000000001,
                to: 96.735,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['chloroform'],
        smiles: 'ClC(Cl)Cl',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['18-crown-6'],
        smiles: 'C1COCCOCCOCCOCCOCCO1',
        ranges: [
            {
                signals: [
                    {
                        delta: 70.14,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.135,
                to: 70.145,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['cyclohexane'],
        smiles: 'C1CCCCC1',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['1,2-dichloroethane'],
        smiles: 'ClCCCl',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['dichloromethane'],
        smiles: 'ClCCl',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 14.77,
                        assignment: 'CH₃',
                    },
                ],
                from: 14.764999999999999,
                to: 14.775,
            },
            {
                signals: [
                    {
                        delta: 66.42,
                        assignment: 'CH₂',
                    },
                ],
                from: 66.415,
                to: 66.425,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['diglyme'],
        smiles: 'COCCOCCOC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.665,
                to: 58.675000000000004,
            },
            {
                signals: [
                    {
                        delta: 70.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 70.045,
                to: 70.05499999999999,
            },
            {
                signals: [
                    {
                        delta: 71.63,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.625,
                to: 71.63499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['dimethylformamide'],
        smiles: 'C(=O)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 165.53,
                        assignment: 'CH',
                    },
                ],
                from: 165.525,
                to: 165.535,
            },
            {
                signals: [
                    {
                        delta: 37.54,
                        assignment: 'CH₃',
                    },
                ],
                from: 37.535,
                to: 37.545,
            },
            {
                signals: [
                    {
                        delta: 32.03,
                        assignment: 'CH₃',
                    },
                ],
                from: 32.025,
                to: 32.035000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['1,4-dioxane'],
        smiles: 'C1COCCOC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 67.19,
                        assignment: 'CH₂',
                    },
                ],
                from: 67.185,
                to: 67.195,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['DME', 'diethyl ether'],
        smiles: 'CCOCC',
        ranges: [
            {
                signals: [
                    {
                        delta: 58.67,
                        assignment: 'CH₃',
                    },
                ],
                from: 58.665,
                to: 58.675000000000004,
            },
            {
                signals: [
                    {
                        delta: 71.49,
                        assignment: 'CH₂',
                    },
                ],
                from: 71.485,
                to: 71.49499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethane'],
        smiles: 'CC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethanol'],
        smiles: 'CCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 17.47,
                        assignment: 'CH₃',
                    },
                ],
                from: 17.465,
                to: 17.474999999999998,
            },
            {
                signals: [
                    {
                        delta: 58.05,
                        assignment: 'CH₂',
                    },
                ],
                from: 58.044999999999995,
                to: 58.055,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethyl acetate'],
        smiles: 'CC(=O)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 21.15,
                        assignment: 'CH₃CO',
                    },
                ],
                from: 21.145,
                to: 21.154999999999998,
            },
            {
                signals: [
                    {
                        delta: 175.26,
                        assignment: 'CO',
                    },
                ],
                from: 175.255,
                to: 175.265,
            },
            {
                signals: [
                    {
                        delta: 62.32,
                        assignment: 'CH₂',
                    },
                ],
                from: 62.315,
                to: 62.325,
            },
            {
                signals: [
                    {
                        delta: 13.92,
                        assignment: 'CH₃',
                    },
                ],
                from: 13.915,
                to: 13.925,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethylene'],
        smiles: 'C=C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['ethylene glycol'],
        smiles: 'OCCO',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.17,
                        assignment: 'CH₂',
                    },
                ],
                from: 63.165,
                to: 63.175000000000004,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['H grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['hexamethylbenzene'],
        smiles: 'CC1=C(C(=C(C(=C1C)C)C)C)C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['n-hexane'],
        smiles: 'CCCCCC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['HMDSO'],
        smiles: 'C[Si](C)(C)O[Si](C)(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 2.31,
                        assignment: 'CH₃',
                    },
                ],
                from: 2.305,
                to: 2.315,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['HMPA'],
        smiles: 'CN(C)P(=O)(N(C)C)N(C)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 36.46,
                        assignment: 'CH₃',
                    },
                ],
                from: 36.455,
                to: 36.465,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['imidazole'],
        smiles: 'C1=CN=CN1',
        ranges: [
            {
                signals: [
                    {
                        delta: 136.65,
                        assignment: 'CH(2)',
                    },
                ],
                from: 136.645,
                to: 136.655,
            },
            {
                signals: [
                    {
                        delta: 122.43,
                        assignment: 'CH(4,5)',
                    },
                ],
                from: 122.42500000000001,
                to: 122.435,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['methane'],
        smiles: 'C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['methanol'],
        smiles: 'CO',
        ranges: [
            {
                signals: [
                    {
                        delta: 49.5,
                        assignment: 'CH₃',
                    },
                ],
                from: 49.495,
                to: 49.505,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['nitromethane'],
        smiles: 'C[N+](=O)[O-]',
        ranges: [
            {
                signals: [
                    {
                        delta: 63.22,
                        assignment: 'CH₃',
                    },
                ],
                from: 63.214999999999996,
                to: 63.225,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['n-pentane'],
        smiles: 'CCCCC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['propane'],
        smiles: 'CCC',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['2-propanol'],
        smiles: 'CC(O)C',
        ranges: [
            {
                signals: [
                    {
                        delta: 24.38,
                        assignment: 'CH₃',
                    },
                ],
                from: 24.375,
                to: 24.384999999999998,
            },
            {
                signals: [
                    {
                        delta: 64.88,
                        assignment: 'CH',
                    },
                ],
                from: 64.875,
                to: 64.88499999999999,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['propylene'],
        smiles: 'CC=C',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['pyridine'],
        smiles: 'C1=CC=NC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 149.18,
                        assignment: 'CH(2,6)',
                    },
                ],
                from: 149.175,
                to: 149.185,
            },
            {
                signals: [
                    {
                        delta: 125.12,
                        assignment: 'CH(3,5)',
                    },
                ],
                from: 125.11500000000001,
                to: 125.125,
            },
            {
                signals: [
                    {
                        delta: 138.27,
                        assignment: 'CH(4)',
                    },
                ],
                from: 138.26500000000001,
                to: 138.275,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['pyrrole'],
        smiles: 'C1=CNC=C1',
        ranges: [
            {
                signals: [
                    {
                        delta: 119.06,
                        assignment: 'CH(2,5)',
                    },
                ],
                from: 119.055,
                to: 119.065,
            },
            {
                signals: [
                    {
                        delta: 107.83,
                        assignment: 'CH(3,4)',
                    },
                ],
                from: 107.825,
                to: 107.835,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['pyrrolidine'],
        smiles: 'C1CCNC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 46.83,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 46.824999999999996,
                to: 46.835,
            },
            {
                signals: [
                    {
                        delta: 25.86,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.855,
                to: 25.865,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['silicone grease'],
        smiles: '',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['tetrahydrofuran'],
        smiles: 'C1COCC1',
        ranges: [
            {
                signals: [
                    {
                        delta: 68.68,
                        assignment: 'CH₂(2,5)',
                    },
                ],
                from: 68.67500000000001,
                to: 68.685,
            },
            {
                signals: [
                    {
                        delta: 25.67,
                        assignment: 'CH₂(3,4)',
                    },
                ],
                from: 25.665000000000003,
                to: 25.675,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['toluene'],
        smiles: 'Cc1ccccc1',
        ranges: [],
        nucleus: '13C',
        solvent: 'D₂O',
    },
    {
        names: ['triethylamine'],
        smiles: 'CCN(CC)CC',
        ranges: [
            {
                signals: [
                    {
                        delta: 9.07,
                        assignment: 'CH₃',
                    },
                ],
                from: 9.065,
                to: 9.075000000000001,
            },
            {
                signals: [
                    {
                        delta: 47.19,
                        assignment: 'CH₂',
                    },
                ],
                from: 47.184999999999995,
                to: 47.195,
            },
        ],
        nucleus: '13C',
        solvent: 'D₂O',
    },
];
//# sourceMappingURL=carbonImpurities.js.map